module.exports = __webpack_public_path__ + "img/business-icon4-click.77c9fbb4.png";